<script lang="ts">
  import SalesRepPage from "@distributor/svelte/Employees/SalesRepPage.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";

  const fetchSalesRep = () => {
    return HttpPromise({
      method: "GET",
      url: `/api/distributor/sales_reps/${$params.salesRepId}`,
    });
  };
</script>

{#await fetchSalesRep()}
  <Spinner />
{:then salesRep}
  <SalesRepPage {salesRep} />
{/await}
